import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Modal, Grid, Paper, Button, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import { ParentsContent } from './parents/parentsContent';
import { StudentsContent } from './students/studentsContent';
import { ParentsSubscribe } from './parents/parentsSubscribe';
import { StudentsSubscribe } from './students/studentsSubscribe';
import Cookies from 'js-cookie';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: '90%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  overflow: { xs: 'auto', sm: 'hidden' },
  maxWidth: '1000px',
  display: 'flex',
  flexDirection: 'column',
};

export const SubscribeModal = ({user, type}) => {
  const [showScrollButton, setShowScrollButton] = useState(true);
  const [open, setOpen] = useState(true);
  const modalRef = useRef(null);
  const subscriptionSectionRef = useRef(null);
  const contentRef = useRef(null);

  const canClose = type === "student" 
    ? user.educator_count > 0 && user.parent_count > 0
    : user.educator_count > 0;

  const handleClose = () => {
    setOpen(false);
    Cookies.set('subscribeModalClosed', 'true', { expires: 30 });
  };

  useEffect(() => {
    const modalClosed = Cookies.get('subscribeModalClosed');
    if (modalClosed === 'true') {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          setShowScrollButton(!entries[0].isIntersecting);
        },
        {
          root: window.innerWidth >= 600 ? contentRef.current : null,
          threshold: 0.3,
          rootMargin: '-100px 0px 0px 0px'
        }
      );

      if (subscriptionSectionRef.current) {
        observer.observe(subscriptionSectionRef.current);
      }

      return () => {
        if (subscriptionSectionRef.current) {
          observer.unobserve(subscriptionSectionRef.current);
        }
      };
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const scrollToSubscription = () => {
    if (subscriptionSectionRef.current) {
      subscriptionSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <React.Fragment>
      <Modal
        open={user.account_soft_locked && open}
      >
        <Box sx={style} ref={modalRef}>
          {canClose && (
            <IconButton
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'text.secondary',
                zIndex: 1,
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
          <Box sx={{ flex: 1, overflow: { xs: 'auto', sm: 'hidden' }, position: 'relative' }} ref={contentRef}>
            <Grid container component="main" sx={{ height: { xs: 'auto', sm: '100%' } }}>
              <Grid
                item
                xs={12}
                sm={6}
                md={7}
                sx={{ height: { xs: 'auto', sm: '100%' } }}
              >
                {type === "student" ? <StudentsContent user={user} /> : <ParentsContent user={user} />}
              </Grid>
              <Grid 
                item 
                xs={12} 
                sm={6} 
                md={5} 
                p={2} 
                sx={{ 
                  height: { xs: 'auto', sm: '100%' }, 
                  borderLeft: { xs: 'none', sm: '1px solid #e0e0e0' }, 
                  overflowY: { xs: 'visible', sm: 'auto' },
                  display: 'flex',
                  flexDirection: 'column'
                }}
                ref={subscriptionSectionRef}
              >
                <Typography variant="h6" component="div" color='primary' sx={{ mb: 2, textAlign: 'center' }}>7 Day Free Trial. Cancel Anytime!</Typography>
                {type === "student" ? <StudentsSubscribe user={user} /> : <ParentsSubscribe user={user} />}
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              display: { xs: 'block', sm: 'none' },
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
              padding: '10px',
              backgroundColor: 'transparent',
              pointerEvents: 'none',
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={scrollToSubscription}
              disableElevation
              sx={{
                display: showScrollButton ? 'block' : 'none',
                width: '90%',
                maxWidth: '400px',
                margin: '0 auto',
                padding: '10px 20px 15px 20px',
                pointerEvents: 'auto',
                '& .bounce-arrow': {
                  animation: 'bounce 1s infinite',
                  marginLeft: '8px',
                },
                '@keyframes bounce': {
                  '0%, 100%': {
                    transform: 'translateY(0)',
                  },
                  '50%': {
                    transform: 'translateY(5px)',
                  },
                },
              }}
            >
              Subscribe Below!
              <KeyboardArrowDownIcon className="bounce-arrow" />
            </Button>
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  );
};